<template>
<div class="container-fluid">
    <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
      <h3>Create App</h3>
      <hr/>
      <b-card>
        <b-form @submit="onSubmit">
          <!-- App Name -->
          <b-form-group
            id="input-group-1"
            label="App name:"
            label-for="input-1"
            description="Name for show in app store."
            >
          <b-form-input
            id="input-1"
            v-model="form.name"
            type="text"
            required
            placeholder="Enter app name"
          ></b-form-input>
          </b-form-group>

          <!-- Bundle Id -->
          <b-form-group
            label="Bundle ID:"
            label-for="input-2"
            description="Bundle id must be same in apk, ipa file when you upload."
            >
          <b-form-input
            id="input-2"
            v-model="form.bundleId"
            type="text"
            required
            placeholder="Enter bundle id"
          ></b-form-input>
          </b-form-group>

          <!-- Platform -->
          <b-form-group
            label="Platform:"
            label-for="input-3"
            >
          <b-form-select
            id="input-3"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'Choose platform ...', value: null }, 'android', 'ios']"
            required
            v-model="form.platform"
          ></b-form-select>
          </b-form-group>

          <!-- Description -->
          <b-form-group
            label="Description:"
            label-for="input-4"
            >
          <b-form-textarea
            id="input-4"
            v-model="form.description"
            placeholder="Enter descirption..."
            rows="3"
            max-rows="4"
            required
          ></b-form-textarea>
          </b-form-group>
          <div>
            <b-button class="mx-3" size="sm" type="submit" variant="primary">Submit</b-button>
            <b-button @click="$router.go(-1)" class="mx-3" size="sm" variant="secondary">Cancel</b-button>
          </div>

        </b-form>
      </b-card>
  </div>
</template>

<script>
import Loading from '../../components/Loading';

export default {
  data () {
    return {
      isLoading: false,
      form: {
        name: '',
        bundleId: '',
        platform: null,
        description: ''
      }
    };
  },
  methods: {
    onSubmit (e) {
      e.preventDefault();
      this.isLoading = true;
      this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/app-store/app', this.form)
        .then(response => {
          const data = response.data.data;
          const id = data.appStore.id;
          sessionStorage.setItem('app', JSON.stringify(data.appStore));
          this.$router.replace({ name: 'apps2-details-2', params: { id } });
        })
        .catch(error => console.log(error))
        .finally(this.isLoading = false);
    }
  },
  computed: {
  },
  mounted () {
    document.title = 'Admin Console: Create App';
  },
  components: {
    'app-loading': Loading
  }
};
</script>
<style src="@/assets/css/appstore-landing2.css"></style>
